/* src/app/pages/home/crousel/crousel.component.scss */
/*# sourceMappingURL=crousel.component.css.map */
